// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config$PorterinUtils from "../../../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as GoogleVm$PorterinFeature from "../view-model/GoogleVm.mjs";
import * as CommonUtils$PorterinFeature from "../../../../utils/CommonUtils.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as GeocodingApi$PorterinFeature from "../../../../../../shared/geocode/domain/repo/GeocodingApi.mjs";
import * as SpotEstimateVm$PorterinFeature from "../../../../../../shared/spot-lead-flow/view/view-model/SpotEstimateVm.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../../domain/store/FareEstimateStoreV1.mjs";
import * as LocationInfoActionCmp$PorterinFeature from "./LocationInfoActionCmp.mjs";
import * as MapModCmp$PorterinFusionkitGoogleMaps from "../../../../../../../../../node_modules/@porterin/fusionkit-google-maps/src/view/MapModCmp.mjs";
import * as MarkerModCmp$PorterinFusionkitGoogleMaps from "../../../../../../../../../node_modules/@porterin/fusionkit-google-maps/src/view/MarkerModCmp.mjs";
import * as LocationAccuracyCmpModuleScss from "../styles/LocationAccuracyCmp.module.scss";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../domain/helpers/FareEstimateAnalyticsHelper.mjs";
import * as GoogleReactAutocompleteHelper$PorterinFeature from "../../../../../../shared/core/helpers/GoogleReactAutocompleteHelper.mjs";
import * as LocationAccuracyCmpStateMachine$PorterinFeature from "../view-model/state-machine/LocationAccuracyCmpStateMachine.mjs";
import * as MapPinLocationProps$PorterinFusionkitGoogleMaps from "../../../../../../../../../node_modules/@porterin/fusionkit-google-maps/src/entities/MapPinLocationProps.mjs";

var styles = LocationAccuracyCmpModuleScss;

function LocationAccuracyCmp(Props) {
  var waypoint = Props.waypoint;
  var center_position = Props.center_position;
  var open_select_location = Props.open_select_location;
  var on_location_select = Props.on_location_select;
  var location_address = Props.location_address;
  var match = React.useReducer(LocationAccuracyCmpStateMachine$PorterinFeature.reducer, LocationAccuracyCmpStateMachine$PorterinFeature.getInitialState(location_address.address, location_address.postalAddress, center_position));
  var state = match[0];
  var showMarker = state.showMarker;
  var mapCenter = state.mapCenter;
  var map = state.map;
  var dispatch = match[1];
  var anchor = {
    x: 118,
    y: 77
  };
  var markerRef = React.useRef(null);
  var marker_iconData = {
    TAG: /* Img */0,
    _0: SpotEstimateVm$PorterinFeature.input_to_icon.src
  };
  var marker = {
    location: mapCenter,
    iconData: marker_iconData
  };
  var setMarkerRef = function (element) {
    markerRef.current = element;
  };
  var markerIcon = waypoint ? GoogleVm$PorterinFeature.drop_pin_tool_tip.src : GoogleVm$PorterinFeature.pickup_pin_tool_tip.src;
  var setAddress = function (selected_address, selected_geoAddress) {
    Curry._1(dispatch, {
          TAG: /* SetSelectedAddress */3,
          _0: selected_address
        });
    Curry._1(dispatch, {
          TAG: /* SetGeoPostalAddress */4,
          _0: selected_geoAddress
        });
  };
  var updateLocation = function (func) {
    GeocodingApi$PorterinFeature.getGeocodeFromLatLng(mapCenter, (function (geocode) {
            GoogleReactAutocompleteHelper$PorterinFeature.setGeocodingAddress(geocode, func);
          }), (function (param) {
            Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "Error on google geo code custom with retry");
          }));
  };
  var onDragEnd = function (param) {
    if (map === null) {
      return ;
    }
    var currentCenter_lat = Curry._1(map.getCenter().lat, undefined);
    var currentCenter_lng = Curry._1(map.getCenter().lng, undefined);
    var currentCenter = {
      lat: currentCenter_lat,
      lng: currentCenter_lng
    };
    updateLocation(setAddress);
    Curry._1(dispatch, {
          TAG: /* SetShowMarker */2,
          _0: false
        });
    Curry._1(dispatch, {
          TAG: /* SetMapCenter */1,
          _0: currentCenter
        });
  };
  var onDragStart = function (param) {
    Curry._1(dispatch, {
          TAG: /* SetShowMarker */2,
          _0: true
        });
  };
  return React.createElement("div", {
              className: styles.container
            }, React.createElement(MapModCmp$PorterinFusionkitGoogleMaps.make, {
                  props: MapPinLocationProps$PorterinFusionkitGoogleMaps.makeProps("location-accuracy-map", mapCenter, CommonUtils$PorterinFeature.debounce(onDragEnd, 200), (function (param) {
                          
                        }), map, (function (val) {
                          Curry._1(dispatch, {
                                TAG: /* SetMap */0,
                                _0: val
                              });
                        }), onDragStart, marker, markerIcon, anchor, setMarkerRef, showMarker, "location-accuracy-marker", styles["map-container"]),
                  children: showMarker ? React.createElement("img", {
                          className: styles["drag-in-marker"],
                          src: waypoint ? GoogleVm$PorterinFeature.drop_pin_icon.src : GoogleVm$PorterinFeature.pickup_pin_icon.src
                        }) : React.createElement(MarkerModCmp$PorterinFusionkitGoogleMaps.make, {
                          marker: marker,
                          anchor: anchor,
                          marker_key: "location-accuracy-marker",
                          marker_icon: markerIcon,
                          set_marker_ref: setMarkerRef
                        }),
                  map_api_key: Config$PorterinUtils.google_maps_api_key
                }), showMarker ? null : React.createElement(LocationInfoActionCmp$PorterinFeature.make, {
                    waypoint: waypoint,
                    on_click: (function (param) {
                        var eventName = waypoint ? FareEstimateStoreV1$PorterinFeature.confirm_drop : FareEstimateStoreV1$PorterinFeature.confirm_pickup;
                        FareEstimateAnalyticsHelper$PorterinFeature.publishLocationAccuracyEvent(eventName);
                        updateLocation(on_location_select);
                      }),
                    open_select_location: open_select_location,
                    location_address: {
                      address: state.selectedAddress,
                      postalAddress: state.geoPostalAddress
                    },
                    set_current_location: (function (lat, lng) {
                        updateLocation(setAddress);
                        Curry._1(dispatch, {
                              TAG: /* SetMapCenter */1,
                              _0: {
                                lat: lat,
                                lng: lng
                              }
                            });
                      })
                  }));
}

var make = LocationAccuracyCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
